/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { Oas20Response } from '../../openapi/v2/models/Oas20Response';

/**
 * A command used to delete a single example.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteExampleCommand_20 extends AbstractCommand {
    public _exampleContentType : string;

    public _responsePath : NodePath;

    public _oldExample : any;

    public constructor(response? : any, contentType? : any) {
        if(((response != null && response instanceof <any>Oas20Response) || response === null) && ((typeof contentType === 'string') || contentType === null)) {
            let __args = arguments;
            super();
            if(this._exampleContentType===undefined) this._exampleContentType = null;
            if(this._responsePath===undefined) this._responsePath = null;
            if(this._oldExample===undefined) this._oldExample = null;
            if(this._exampleContentType===undefined) this._exampleContentType = null;
            if(this._responsePath===undefined) this._responsePath = null;
            if(this._oldExample===undefined) this._oldExample = null;
            (() => {
                this._responsePath = Library.createNodePath(response);
                this._exampleContentType = contentType;
            })();
        } else if(response === undefined && contentType === undefined) {
            let __args = arguments;
            super();
            if(this._exampleContentType===undefined) this._exampleContentType = null;
            if(this._responsePath===undefined) this._responsePath = null;
            if(this._oldExample===undefined) this._oldExample = null;
            if(this._exampleContentType===undefined) this._exampleContentType = null;
            if(this._responsePath===undefined) this._responsePath = null;
            if(this._oldExample===undefined) this._oldExample = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteExampleCommand] Executing.");
        this._oldExample = null;
        let response : Oas20Response = <Oas20Response>this._responsePath.resolve(document);
        if(this.isNullOrUndefined(response) || this.isNullOrUndefined(response.examples) || this.isNullOrUndefined(response.examples.getExample(this._exampleContentType))) {
            LoggerCompat.debug("[DeleteExampleCommand] No example with content-type: " + this._exampleContentType);
            return;
        }
        this._oldExample = response.examples.removeExample(this._exampleContentType);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteExampleCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldExample)) {
            return;
        }
        let response : Oas20Response = <Oas20Response>this._responsePath.resolve(document);
        if(this.isNullOrUndefined(response)) {
            return;
        }
        if(this.isNullOrUndefined(response.examples)) {
            response.examples = response.createExample();
        }
        response.examples.addExample(this._exampleContentType, this._oldExample);
    }
}
DeleteExampleCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteExampleCommand_20";
DeleteExampleCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

